import React, { useCallback } from 'react';
import { getIn } from 'formik';

import { Radio } from '../../radio';
import { FieldElementPropTypes } from '../propTypes';

const RadioField = ({
  field: { id, name, mode, options, value, ...props },
  ctx: { setFieldValue, touched, errors, setFieldTouched, classes }
}) => {
  const onChange = useCallback(
    (e) => {
      let fieldValue = e.target.value;

      // Convert string boolean values back to actual booleans
      if (fieldValue === 'true') {
        fieldValue = true;
      } else if (fieldValue === 'false') {
        fieldValue = false;
      }

      setFieldValue(name || id, fieldValue);
      setFieldTouched(id, true, false);
    },
    [setFieldTouched, setFieldValue, id, name]
  );

  // Convert boolean option values to strings for the Radio component
  const normalizedOptions = options.map((option) => ({
    ...option,
    value: option.value === true ? 'true' : option.value === false ? 'false' : option.value
  }));

  return (
    <Radio
      key={id}
      id={id}
      name={name || id}
      value={value === true ? 'true' : value === false ? 'false' : value || ''}
      mode={mode}
      options={normalizedOptions}
      classes={classes[id]}
      onChange={onChange}
      error={getIn(touched, name || id) && !!getIn(errors, name || id)}
      helperText={getIn(touched, name || id) ? getIn(errors, name || id) : undefined}
      {...props}
    />
  );
};

RadioField.propTypes = FieldElementPropTypes;

export default RadioField;
